import React, { useCallback } from 'react';
import {
    HeaderTextProps,
} from 'ui-components/share-report-modal/share-report-modal';
import styles from './share-modal.module.scss';

export const useGetHeaderTextPropsContent = () => {
    return useCallback(
        (headerContent: HeaderTextProps) => (
            <>
                <div className={styles.primaryText}>{headerContent.primaryText}</div>
                <div className={styles.secondaryText}>{headerContent.secondaryText}</div>
                <div>{headerContent.tertiaryText}</div>
            </>
        ),
        [],
    );
};